import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookie-consent-v1';

const CookieConsentPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      setIsVisible(window.localStorage.getItem(COOKIE_CONSENT_KEY) !== 'accepted');
    } catch {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    try {
      window.localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    } catch {
      // If storage is unavailable, still close the popup for this session.
    }

    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:bottom-6">
      <div
        className="mx-auto max-w-4xl rounded-lg border border-gray-200 bg-white p-4 text-gray-900 shadow-2xl sm:p-5"
        role="dialog"
        aria-modal="false"
        aria-label="Informare privind cookie-urile"
      >
        <div className="flex items-start gap-4">
          <div className="hidden h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary sm:flex">
            <Cookie className="h-6 w-6" aria-hidden="true" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="mb-2 flex items-start justify-between gap-3">
              <h2 className="text-base font-bold text-primary sm:text-lg">
                Informare privind cookie-urile
              </h2>
              <button
                type="button"
                onClick={acceptCookies}
                className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary"
                aria-label="Închide informarea privind cookie-urile"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <p className="text-sm leading-relaxed text-gray-700">
              Folosim cookie-uri strict necesare și stocare locală pentru funcționarea site-ului și pentru reținerea preferințelor, inclusiv setările de accesibilitate. Nu folosim în prezent cookie-uri de marketing în interfața publică.
            </p>

            <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={acceptCookies}
                className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              >
                Am înțeles
              </button>
              <Link
                to="/politica-cookie"
                onClick={acceptCookies}
                className="inline-flex items-center justify-center rounded-md border border-primary px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              >
                Citește politica privind cookie-urile
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentPopup;
